module.exports = __webpack_public_path__ + "static/tr-finans-4-07642f60463a3b2cea31ecaf7b151da8.png";